// extracted by css-extract-rspack-plugin
export default {"customSalary":"custom-salary--Hg2a3GM3sEZYtZgq","input":"input--PZeppOBVZv4NvTch"};